import logo from './logo.png'

export const theme = {
    color: {
      primary: "#005daa",
      primaryHover: "#004D8D",
    },
    logoImage: logo,
    backend: "https://rundschau.michel.de/",
    directory: "/",
    header: {
      customer: "",
      title: "MICHEL-Rundschau",
      lineHeader: true,
    },
    info: [
      {
        text: 'Briefmarken.de',
        link: 'https://shop.briefmarken.de/de/'
      },
      {
        text: 'Impressum',
        link: 'https://shop.briefmarken.de/de/impressum'
      },
      {
        text: 'Datenschutz',
        link: 'https://shop.briefmarken.de/de/privatsphaere-und-datenschutz'
      },
      {
        text: 'AGB',
        link: 'https://shop.briefmarken.de/de/unsere-agb'
      }
  ],
  login: {
      type: "internal",
      sso: true,
      logoutRedirectUri: "https://www.briefmarken.de/sso_server/logout.php?post_logout_redirect_uri=https://rundschau.michel.de"
    }
  };